import { useEffect, useState } from 'react';

export default function useTick(closure, interval = 1000) {
  const [value, setValue] = useState(closure());

  useEffect(() => {
    const intervalId = setInterval(() => setValue(closure()), interval);

    return () => clearInterval(intervalId);
  }, []);

  return { value };
}
